import { render, staticRenderFns } from "./Blank.vue?vue&type=template&id=2151c819&scoped=true&lang=pug&"
import script from "./Blank.vue?vue&type=script&lang=ts&"
export * from "./Blank.vue?vue&type=script&lang=ts&"
import style0 from "./Blank.vue?vue&type=style&index=0&id=2151c819&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2151c819",
  null
  
)

export default component.exports